"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadModule = exports.loadModuleText = exports.setBackendStaticURL = void 0;
const errors_1 = require("../errors/errors");
const xmlhttprequest_ts_1 = require("xmlhttprequest-ts");
const HttpRequest = typeof window === 'undefined' ? xmlhttprequest_ts_1.XMLHttpRequest : XMLHttpRequest;
let BACKEND_STATIC_URL = 'https://source-academy.github.io/modules';
function setBackendStaticURL(url) {
    BACKEND_STATIC_URL = url;
}
exports.setBackendStaticURL = setBackendStaticURL;
function loadModuleText(path) {
    const scriptPath = `${BACKEND_STATIC_URL}/${path}.js`;
    const req = new HttpRequest();
    req.open('GET', scriptPath, false);
    req.send(null);
    if (req.status !== 200 && req.status !== 304) {
        throw new errors_1.ModuleNotFound(path);
    }
    return req.responseText;
}
exports.loadModuleText = loadModuleText;
function loadModule(path, context, moduleText) {
    try {
        if (moduleText === undefined) {
            moduleText = loadModuleText(path);
        }
        // tslint:disable-next-line:no-eval
        const moduleLib = eval(moduleText);
        return moduleLib(Object.assign({ runes: {} }, context.moduleParams));
    }
    catch (_error) {
        throw new errors_1.ModuleInternalError(path);
    }
}
exports.loadModule = loadModule;
//# sourceMappingURL=moduleLoader.js.map